import { Result } from '@empathy/search-types';
import { RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class SaveRecommendationsMutation implements RecommendationsMutation {

  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.saveRecommendations]: (recommendationsState: RecommendationsState, recommendations: Result[]) => {
      recommendationsState.recommendations = recommendations;
      recommendationsState.hasMore = recommendationsState.lastCount < recommendationsState.recommendations.length;
      recommendationsState.lastCount = recommendationsState.recommendations.length;
    }
  };
}
